module.exports = __webpack_public_path__ + "static/media/edgistify.b66075cf.png";